var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_1307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5812 8.20074C15.5812 3.98396 12.1636 0.566406 7.94683 0.566406C3.73006 0.566406 0.3125 3.98396 0.3125 8.20074C0.3125 12.4175 3.73006 15.8351 7.94683 15.8351C7.99156 15.8351 8.03629 15.8351 8.08103 15.8321V9.89162H6.44084V7.98006H8.08103V6.57248C8.08103 4.94123 9.07707 4.05255 10.5324 4.05255C11.2302 4.05255 11.8296 4.10325 12.0026 4.1271V5.8329H11.0006C10.2103 5.8329 10.0552 6.20865 10.0552 6.76035V7.97707H11.9489L11.7014 9.88864H10.0552V15.5398C13.2461 14.6243 15.5812 11.6869 15.5812 8.20074Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_1307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2687,
    height: 15.2687,
    fill: "white",
    transform: "translate(0.3125 0.566406)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.786253741085599a16e3da1a7100bcdb.svg";
export { ForwardRef as ReactComponent };